<!-- @format -->
<template>
	<pcp-change-pwd v-show="resetPasswordStore.dialogVisible"></pcp-change-pwd>
	<el-container class="pc-layout-main">
		<el-header v-if="pcLayoutHeader" class="pc-layout-main-el-header">
			<pcp-header3 v-if="globalStore.headerType === '3'" :name="globalStore.curSystemAlias" />
			<pcp-header v-else :name="globalStore.curSystemAlias" />
		</el-header>
		<el-container style="overflow-y: auto; overflow-x: hidden">
			<el-aside v-if="pcLayoutMenu" style="width: auto">
				<pcp-side-bar v-model="menuStore.displayMenus" :route="route" :show-only-children="false" />
			</el-aside>
			<el-main style="padding: 0">
				<router-view #="{ Component }">
					<keep-alive max="5" :include="keepAliveStore.list">
						<component :is="Component" :key="route.name" />
					</keep-alive>
				</router-view>
			</el-main>
		</el-container>
	</el-container>
</template>

<script lang="ts" setup>
	import { useGlobalStoreWithOut, useResetPasswordStoreWithOut } from '@power/runtime-vue3';
	import { useKeepAliveStoreWithOut } from '@/store/modules/keepAlive';
	import { useMenuStore } from '@/store/modules/menu';

	import { PcpSideBar, PcpHeader, PcpHeader3, PcpHeaderNomenu, PcpChangePwd } from '@/p-components';

	const resetPasswordStore = useResetPasswordStoreWithOut();

	const is4aUrl = ref(false);
	const globalStore = useGlobalStoreWithOut();
	const menuStore = useMenuStore();
	const route = useRoute();
	const keepAliveStore = useKeepAliveStoreWithOut();

	const pcLayoutHeader = computed(() => globalStore.visible.pcLayoutHeader && route.meta.pcLayoutHeader !== false);
	const pcLayoutMenu = computed(() => globalStore.visible.pcLayoutMenu && route.meta.pcLayoutMenu !== false);
</script>

<style scoped lang="scss">
	.pc-layout-main {
		height: 100%;
	}

	.pc-layout-main-el-header {
		--el-header-padding: 0 26px;
		height: var(--theme-header-height);
		background-color: #020918;
		background-image: var(--theme-pcp-header-background-image);
		background-position: center;
	}
</style>
